"use strict";
/**
 * @file browser
 * @author Cuttle Cong
 * @date 2018/9/8
 */
Object.defineProperty(exports, "__esModule", { value: true });
var makeCreateLogger_1 = require("./makeCreateLogger");
var u = require("util");
exports.Map = {
    Info: ''
};
exports.default = makeCreateLogger_1.default(function (_a, _b) {
    var namespace = _a.namespace, message = _a.message, type = _a.type, argv = _a.argv;
    var _c = _b === void 0 ? {} : _b, _d = _c.prefix, prefix = _d === void 0 ? '(' : _d, _e = _c.suffix, suffix = _e === void 0 ? ')' : _e, _f = _c.typeMap, typeMap = _f === void 0 ? exports.Map : _f;
    var str = namespace !== '' ? "" + prefix + namespace + suffix : namespace;
    message = u.format.apply(u, [message].concat(argv));
    type = typeMap[type] || type || '';
    return "" + type + str + ": " + message;
});
//# sourceMappingURL=browser.js.map